module.exports = __webpack_public_path__ + "static/img/bgc-img.515bbe9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common-img/bgc-img.png
// module id = mUHE
// module chunks = 17